import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import { OutlookAppointmentRecurrenceDto, OutlookRecipientDto } from "@/index";
import { DateTimePeriodDto } from "@/out-look/dto/DateTimePeriodDto";
import { IConvertDateTimeToUTCReq, IConvertDateTimeToUTCResp, IFetchRequest, IFetchResourceRequest, IFilterResource, OrganizationInfo, Organizer } from "@/services";
import { AttendeeInfo } from "@/services/attendee-service/entity/AttendeeEntity";
import { OutLookInfo } from "@/services/organization-service/entity/OutLookEntity";

export interface IResourceFinderProps {
  getOrgInfo?: (outlookUid: string, isReOpen?: boolean, isRecurringMaster?: boolean) => void;
  getSettingOrgInfo?:(payload: IFetchRequest) => void;
  getCategorization?: (tenantId: string, orgId: string) => void;
  updateOutlookInfo?: (outlookInfo: OutLookInfo) => void;
  updateOrganizer?: (org: Organizer) => void;
  updateTimeOfOutlook?: (time: DateTimePeriodDto) => void;
  updateResourceSelectedFromOutlook?: (resources: OutlookRecipientDto[]) => void;
  updateRecurringOfOutlook?: (recurringInfo: OutlookAppointmentRecurrenceDto) => void;
  setTheme?: (themeId: string) => void;
  deleteSelectWhenFromOutlook?: (resourceEmails: string[]) => void;
  getResourcesDataForSelected?: (request: IFetchResourceRequest, outlookRecipientDto : OutlookRecipientDto[], isRecurring?: boolean, orgInfo?: OrganizationInfo) => Promise<void>;
  getAllResourcesDataInSelected?: (request: IFetchResourceRequest, isRecurring?: boolean) => Promise<void>;
  addInitAttendee?: (payload: AttendeeInfo) => void;
  onConvertDateTimeToUTC?: (req: IConvertDateTimeToUTCReq) => Promise<HttpResponse<IConvertDateTimeToUTCResp>>;
  onResetNotification?: () => void;
  updateFilterResource?: (filter: IFilterResource) => void;
}

export enum TAB_LIST {
  HOME = "home",
  RESOURCE = "resources",
  COLLEAGUE = "colleagues",
  SETTING = "setting",
}
